export const EDIT_ACCOUNT_API = '/api/users/me';
